<template>
  <div class="stripfile">
    <div class="stripfile__number">
      <slot name="number"></slot>
    </div>
    <div class="stripfile__name">
      <slot name="name"></slot>
    </div>
    <div class="stripfile__publish">
      <slot name="publish"></slot>
    </div>
    <div class="stripfile__date">
      <slot name="date"></slot>
    </div>
    <div class="stripfile__upload">
      <slot name="upload"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StripFileBody',
};
</script>

<style scoped lang="scss">
.stripfile {
  display: flex;
  align-items: center;
  > div {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
  &__number {
    width: 100px;
  }
  &__name {
    flex: 1;
  }
  &__publish {
    width: 150px;
  }
  &__upload {
    display: flex;
    justify-content: flex-end;
    width: 150px;
    flex: none;
  }
}
</style>
